import { HttpClient } from 'common/HttpClient'
import { Environment } from 'enviroment/AppSettings'
import { ICheckVerificationParams, IGenerateSessionParams, IGenerateSessionResponse, IVideoVerificationVerificationModel } from './VideoVerificationServiceProps'
import { AxiosError } from 'axios'

//#region SettingService Instance
let instance: VideoVerificationService
//#endregion


class VideoVerificationService {
   private readonly _client : HttpClient
   private readonly _generateSessionPath = '/videoVerification/generateSession'
   private readonly _checkIfUserPassVerificationPath = '/videoVerification/checkVerificationResult'
   private readonly _videoVerificationVerificationUrlPath = '/videoVerification/verification'

   constructor(){
      if (instance) { //SINGLETON DESIGN PATTERN
         throw new Error("New instance cannot be created!!");
      }
   
      instance = this;
      this._client = new HttpClient(Environment.apiUrl);
   }

   public async generateSession(generateSessionParams: IGenerateSessionParams): Promise<IGenerateSessionResponse> {
      return (await this._client.post<IGenerateSessionResponse, IGenerateSessionParams>(
         this._generateSessionPath, 
         generateSessionParams,
         true
      )).data;
   }

   public async checkIfUserPassVerification(checkVerificationParams: ICheckVerificationParams): Promise<boolean> {
      return (await this._client.post<boolean, ICheckVerificationParams>(
         this._checkIfUserPassVerificationPath, 
         checkVerificationParams,
         true
      )).data;
   }

   public async videoVerificationVerification(dto: IVideoVerificationVerificationModel): Promise<boolean> {
      try {
         return (await this._client.post<boolean, IVideoVerificationVerificationModel>(
           this._videoVerificationVerificationUrlPath,
           dto,
           true
         )).data
      }
      catch (e) {
         throw new AxiosError(`Nie udało się poprawnie zweryfikować użytkownika`)
      }
   }
}


let videoVerificationService = Object.freeze(new VideoVerificationService())//SINGLETON DESIGN PATTERN
export default videoVerificationService;